import 'css-chunksrc/client/scenes/planzoneResourceGroupCreation/groupCreationForm/resourcesList/resource/user/styles.scss';export default {
  "resource": "_resource_1911f_1",
  "user": "_user_1911f_8",
  "avatar": "_avatar_1911f_21",
  "name": "_name_1911f_33",
  "title": "_title_1911f_42"
};